// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://icodpbwqrjelraereqnk.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imljb2RwYndxcmplbHJhZXJlcW5rIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzgwNjU5NjMsImV4cCI6MjA5MzY0MTk2M30.Rdio5zHR31WrCHERkfdpNM9udXetlW1rsx_jDpeTnmY";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});